import React, { Component } from "react";

import {
  CModal,
  CModalHeader,
  CModalBody,
  CLabel,
  CModalFooter,
  CButton,
  CSpinner,
  CFormGroup,
  CInputGroup,
  CTextarea
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../actions/baseActions";
import URL from "../../config/api";
import axios from "../../config/axios";
import Uploader from "../Uploader/uploader";

import "./css/content.css";

class UploadCreator extends Component {
  constructor(props) {
    super(props);

    this.state = {
      description: "",
      loading: false,
      uploads: []
    };

    this.handleUploadDone = this.handleUploadDone.bind(this);
  }

  handleUploadDone(uploads, names) {
    // Atualiza o estado
    this.setState({ uploads });
  }

  insertUpload() {
    if (this.state.description === "") {
      toastr.warning("Atenção", "Preencha o campo de descrição!");
      return;
    }

    if (this.state.uploads.length === 0) {
      toastr.warning(
        "Atenção",
        "Aguarde o upload do arquivo ou envie um arquivo válido."
      );
      return;
    }

    let obj = {
      description: this.state.description,
      extensions: "*",
      user_id: this.props.user.user.id
    };

    this.setState({ loading: true });

    axios
      .post(`${URL.api}content/upload/insert`, obj, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.setState({ loading: false });
          this.props.getContent({
            type: 18,
            list: [{ id: resp.data.data, name: "Upload" }]
          });
          this.props.onClose();
        },
        error => {
          this.setState({ loading: false });
        }
      );
  }

  render() {
    return (
      <CModal
        show={this.props.show}
        onClose={() => this.props.onClose()}
        centered
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>Inserir upload</CModalHeader>
        <CModalBody>
          <CFormGroup>
            <Uploader
              type="upload"
              maxFiles={1}
              maxFileSize="100MB"
              allowMultiple={false}
              labelIdle='Arraste e solte seu arquivo ou <span class="filepond--label-action">procure</span>'
              done={this.handleUploadDone}
            />

            <CLabel>Descrição</CLabel>
            <CInputGroup>
              <CTextarea
                rows={4}
                value={this.state.description}
                onChange={e => this.setState({ description: e.target.value })}
                placeholder="Descrição do upload"
              />
            </CInputGroup>
          </CFormGroup>
        </CModalBody>
        <CModalFooter>
          <CButton
            color="primary"
            className="d-flex justify-content-center align-items-center"
            disabled={this.state.loading}
            onClick={() => this.insertUpload()}
          >
            <>
              <span style={this.state.loading ? { opacity: 0 } : null}>
                Inserir
              </span>
              {this.state.loading && (
                <CSpinner
                  size="sm"
                  color="white"
                  style={{ position: "absolute" }}
                />
              )}
            </>
          </CButton>
        </CModalFooter>
      </CModal>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(UploadCreator);
